import { NewPeriod } from '@/app/models/period';
import { usePeriodsQuery } from '@/app/services/periodApi';
import { Card, CardContent, MenuItem, Typography } from '@mui/material';
import Select from '@mui/material/Select';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';
import { usePeriod } from '../context/PeriodContext';

function PeriodDetails() {
  const { selectedPeriod, setSelectedPeriod } = usePeriod();
  const { i18n, t } = useTranslation('pmo');

  const { data } = usePeriodsQuery();

  return (
    <Card
      sx={{
        boxShadow: 3,
        display: 'flex',
        minHeight: '72px',
        alignItems: 'center',
        padding: '0 16px',
      }}
    >
      <CardContent
        sx={{
          display: 'flex',
          maxHeight: '24px',
          flex: 1,
          justifyContent: 'space-between',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Typography
            sx={{
              margin: '0 25px',
              fontSize: 13,
              fontWeight: 'bold',
              color: '#4B4B4B',
            }}
          >
            {t('current.period')}:
          </Typography>

          <Select
            value={selectedPeriod || ''}
            size="small"
            sx={{ width: '180px', fontSize: '11px' }}
            onChange={(event) => {
              if (event.target.value) {
                setSelectedPeriod(event.target.value as NewPeriod);
              } else {
                setSelectedPeriod(undefined);
              }
            }}
          >
            {data?.content.map((period) => (
              <MenuItem
                sx={{
                  fontSize: '13px',
                  fontWeight: period === selectedPeriod ? 'bold' : 'normal',
                  color: period === selectedPeriod ? '#F97C06' : '#4B4B4B',
                }}
                key={period.date}
                value={period as any}
              >
                {`${
                  period.date
                    ? DateTime.fromISO(period.date).setLocale(i18n.language).monthLong
                    : '--'
                }/${period.date ? DateTime.fromISO(period.date).year : '--'}`}
              </MenuItem>
            ))}
          </Select>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <Typography sx={{ fontSize: 13, color: '#4B4B4B' }} color="text.secondary">
            {t('imported.pmo.apportionment')}
          </Typography>
          <div
            style={{
              backgroundColor: selectedPeriod?.indirectSharingImported ? '#28A745' : '#808080',
              width: '15px',
              height: '15px',
              borderRadius: '10px',
              marginLeft: '10px',
            }}
          />
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <Typography sx={{ fontSize: 13, color: '#4B4B4B' }} color="text.secondary">
            {t('teacher.payment')}
          </Typography>
          <div
            style={{
              backgroundColor: selectedPeriod?.paymentImported ? '#28A745' : '#808080',
              width: '15px',
              height: '15px',
              borderRadius: '10px',
              marginLeft: '10px',
            }}
          />
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <Typography sx={{ fontSize: 13, color: '#4B4B4B' }} color="text.secondary">
            {t('imported.events')}
          </Typography>
          <div
            style={{
              backgroundColor: selectedPeriod?.eventImported ? '#28A745' : '#808080',
              width: '15px',
              height: '15px',
              borderRadius: '10px',
              marginLeft: '10px',
            }}
          />
        </div>
      </CardContent>
    </Card>
  );
}

export default PeriodDetails;
